/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { getInternalCookie } from 'apmui/common/Cookie';

function getExternalBasePort() {
    let port = window.location.port;
    if (!port) {
        if (window.location.protocol === 'https:') {
            port = '443';
        } else {
            port = '80';
        }
    }
    return port;
}

function objectToParams(obj: object): string {
    return Object.keys(obj)
        .map((key) => key + '=' + obj[key])
        .join('&');
}

function stripBrackets(str: string) {
    if (str.length >= 2 && str[0] === '[' && str[str.length - 1] === ']') {
        return str.substr(1, str.length - 2);
    }
    return str;
}

interface ICustomProtocolLinkOptions {
    protocol: string;
    port: string;
    sid: string;
    server: string;
}

function getCustomProtocolLink(scheme: string, extraValues: Partial<ICustomProtocolLinkOptions>): string {
    let protocol = window.location.protocol;
    if (protocol.indexOf(':') !== -1) {
        protocol = protocol.substr(0, protocol.indexOf(':'));
    }

    if (!extraValues || typeof extraValues !== 'object') {
        extraValues = {};
    }
    extraValues['protocol'] = protocol;
    extraValues['port'] = getExternalBasePort();
    const sid = getInternalCookie('MRHSession');
    // In new implementation we retrieve session id with one time code generated
    // during a resource launch process.
    // Set session id to dummy sid. This is to support backward
    // compatability.
    // F5Vpn.exe(non upgraded client) bails out before upgradation when there is an
    // empty sid. Having a dummy session id ensures that F5Vpn.exe  does not run
    // into exceptions but passess through the inital check succesfully and
    // upgrades(Newer version of Client is installed on BIG-IP).
    if (sid) {
        if (scheme != 'f5-vpn') {
            extraValues['sid'] = sid;
        } else {
            extraValues['sid'] = 'nnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn';
        }
    }
    const host = extraValues['server'];
    if (host) {
        extraValues['server'] = stripBrackets(host);
    }
    const result = scheme + '://' + window.location.host + '?';

    return result + objectToParams(extraValues);
}

export default getCustomProtocolLink;
